import { connect } from 'react-redux';
import ProductAssociationsTable from './ProductAssociationsTable';
import { fetchProductGroupsData, fetchSingleProductGroup } from '../../../../store/associations/actions';
import { getProductGroups } from '../../../../store/associations/selectors';
import { getModals } from '../../../../store/modals/selectors';
import { setOpenModal } from '../../../../store/modals/actions';
import { deleteContent } from '../../../../store/commons/actions';

const mapStateToProps = (state) => ({
  modals: getModals(state),
  groups: getProductGroups(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductGroupsData: (
    filterName,
    filterValue,
  ) => dispatch(
    fetchProductGroupsData(
      filterName,
      filterValue,
    ),
  ),
  fetchSingleProductGroup: (productGroupNumber, productIRI, products) => {
    dispatch(fetchSingleProductGroup(productGroupNumber, productIRI, products));
  },
  setOpenModal: (modal, value) => {
    dispatch(setOpenModal(modal, value));
  },

  deleteContent: (destination) => dispatch(deleteContent(destination)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductAssociationsTable);
